import { Component, ElementRef, OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TitleService, VERSION as VERSION_ALAIN } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { VERSION as VERSION_ZORRO } from 'ng-zorro-antd/version';
import { filter } from 'rxjs/operators';
import { CommonService } from './modules/service/common/common.service';
import { NzIconService } from 'ng-zorro-antd/icon';
import { LoadingService } from '@delon/abc/loading';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    el: ElementRef,
    renderer: Renderer2,
    private router: Router,
    private titleSrv: TitleService,
    private modalSrv: NzModalService,
    private common: CommonService,
    private iconService: NzIconService,
    private loadingSrv: LoadingService,
  ) {
    renderer.setAttribute(el.nativeElement, 'ng-alain-version', VERSION_ALAIN.full);
    renderer.setAttribute(el.nativeElement, 'ng-zorro-version', VERSION_ZORRO.full);
    this.iconService.fetchFromIconfont({
      scriptUrl: this.common.iconFont,
    });
    // 当页面刷新时  移除页面缓存配置
    window.addEventListener('beforeunload', (res) => {
      this.common.removeCache('pageData');
    });
  }

  ngOnInit(): void {
    this.router.events.pipe(filter((evt) => evt instanceof NavigationEnd)).subscribe(() => {
      this.titleSrv.setTitle();
      this.modalSrv.closeAll();
    });
    // if (localStorage.getItem('channel_id') == null) {
    //   this.router.navigateByUrl('/passport/login');
    // }
  }

  ngAfterViewInit(): void {
    let screen: any = this.common.getCache('screen'); // 获取屏幕宽高
    if (!screen) {
      screen = { width: window.innerWidth, height: window.innerHeight };
      this.common.setCache('screen', screen);
    }
    /**
     * 接收非子级模块传送的数据
     */
    this.common.childToParent$.subscribe((event: string) => {
      const params = JSON.parse(event);
      // console.log(params);
      if (params['status'] == true) {
        this.show();
      } else {
        this.close();
      }
    });
  }

  show(): void {
    this.loadingSrv.open({});
  }

  close(): void {
    this.loadingSrv.close();
  }
}
